import React, { useState } from 'react';
import { Squad, supabase } from '../lib/supabase';
import './VoteQuestion.css';

interface VoteQuestionProps {
  voterSquad: Squad;
  onVoteComplete: () => void;
}

const VoteQuestion: React.FC<VoteQuestionProps> = ({ voterSquad, onVoteComplete }) => {
  const [selectedSquad, setSelectedSquad] = useState<Squad | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // 본인 소속을 제외한 스쿼드 목록
  const availableSquads: { key: Squad; name: string; color: string }[] = [
    { key: 'core' as Squad, name: '<span style="color: #64B5F6;">Core</span> squad', color: '#64B5F6' },
    { key: 'sync' as Squad, name: '<span style="color: #74d075;">Sync</span> squad', color: '#74d075' },
    { key: 'flow' as Squad, name: '<span style="color: #FFA726;">Flow</span> squad', color: '#FFA726' }
  ].filter(squad => squad.key !== voterSquad);

  const handleVote = async () => {
    if (!selectedSquad) {
      setError('투표할 스쿼드를 선택해주세요.');
      return;
    }

    setIsSubmitting(true);
    setError(null);

    try {
      const { error: insertError } = await supabase
        .from('votes')
        .insert({
          voter_squad: voterSquad,
          selected_squad: selectedSquad,
          question: '오늘 발표한 AI 관련 내용에 우수한 평가를 주고 싶은 스쿼드는?'
        });

      if (insertError) {
        throw insertError;
      }

      onVoteComplete();
    } catch (err) {
      console.error('투표 저장 중 오류:', err);
      setError('투표 저장 중 오류가 발생했습니다. 다시 시도해주세요.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="vote-question">
      <h2>투표 질문</h2>
      <div className="question-text">
        <p>오늘 발표한 AI 관련 내용에 우수한 평가를 주고 싶은 스쿼드는?</p>
        <p className="note">※ 본인 소속 스쿼드는 제외됩니다</p>
      </div>
      
      <div className="squad-options">
        {availableSquads.map((squad) => (
          <label 
            key={squad.key} 
            className="option-label"
            style={{ '--squad-color': squad.color } as React.CSSProperties}
          >
            <input
              type="radio"
              name="selectedSquad"
              value={squad.key}
              checked={selectedSquad === squad.key}
              onChange={(e) => setSelectedSquad(e.target.value as Squad)}
            />
            <span className="option-text" dangerouslySetInnerHTML={{ __html: squad.name }}></span>
          </label>
        ))}
      </div>

      {error && <div className="error-message">{error}</div>}

      <button
        className="submit-button"
        onClick={handleVote}
        disabled={!selectedSquad || isSubmitting}
      >
        {isSubmitting ? '투표 중...' : '투표하기'}
      </button>
    </div>
  );
};

export default VoteQuestion;
